import React, { useState } from 'react';
import PropTypes, { InferProps } from 'prop-types';

import Results from '../../components/Results/Results.tsx';

const propTypes = {
  loaded: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.element),
  submitted: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleClear: PropTypes.func,
};

export default function AppLayout(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { loaded, fields, submitted, results, handleSubmit, handleClear } =
    props;

  const makeResults = () => {
    if (submitted) {
      if (results.length > 0) {
        return (
          <>
            <hr />
            <Results data={results} />
            <div className="Actions">
              <button
                type="button"
                name="reset"
                value="reset"
                className="action search"
                onClick={handleClear}
              >
                New Search
              </button>
            </div>
          </>
        );
      } else {
        return (
          <div style={{ fontSize: '1.6rem' }}>
            <hr />
            No results were found
          </div>
        );
      }
    }
  };

  const makeForm = () => (
    <>
      <form id="Form_Form" onSubmit={handleSubmit}>
        <fieldset>
          {fields}
          <div className="Actions">
            <button
              type="button"
              name="reset"
              value="reset"
              className="action reset"
              onClick={handleClear}
            >
              Reset
            </button>
            <button
              type="submit"
              name="search"
              value="search"
              className="action search"
            >
              Search
            </button>
          </div>
        </fieldset>
      </form>
      {makeResults()}
    </>
  );

  return loaded ? makeForm() : <h3>Loading data...</h3>;
}
